// hooks/useCotaUsuario.ts
import { useState, useEffect } from "react";
import { estadoService } from "../services/estadoService";
import { Estado } from "../interfaces/Estado";

export const useEstado = (fetch: boolean) => {
  const [isLoading, setIsLoading] = useState(true);
  const [estados, setEstados] = useState<Estado[]>([]);

  useEffect(() => {
    const fetchEstado = async () => {
      if (fetch) {
        setIsLoading(true);
        try {
          const data = await estadoService();
          if (data) {
            setEstados(data);
          } else {
            console.error("Dados não encontrados para o usuário");
          }
        } catch (error) {
          console.error("Erro ao buscar estados:", error);
        } finally {
          setIsLoading(false);
        }
      } else {
        setIsLoading(false);
      }
    };

    fetchEstado();
  }, [fetch]); // Dependência de aptoId e fetch para garantir que a chamada seja feita quando necessário

  return { isLoading, estados };
};
